import Moment from 'moment'

export default function dayName(value, format = 'ddd') {
  if (value) {
    return Moment(value, 'd').format(format)
  }
  return value
}
